import type { Contributions } from "$types";
import { type Writable } from "svelte/store";
import { writable } from "svelte/store";
import { persisted } from "svelte-local-storage-store";

// Get the value out of storage on load. & browser checked
export const page_size = persisted("page_size", 25);
// Toggle mobile thumb size
export const mobile_size_large = persisted("mobile_size_large", true);
// browser checked
export const active_page = writable(1);
// browser checked
export const is_search_mode_on: Writable<boolean> = writable(false);
// browser checked
export const results: Writable<Contributions[]> = writable([]);

export const active_filter = writable(0);
export const filters = [
  "All Contributions",
  "Members",
  "Extra Images",
  "Process Videos",
];
